import { render, staticRenderFns } from "./CartSuggested.vue?vue&type=template&id=5d1cfc70&scoped=true"
import script from "./CartSuggested.vue?vue&type=script&lang=js"
export * from "./CartSuggested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1cfc70",
  null
  
)

export default component.exports